"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _generalStore = _interopRequireDefault(require("general-store"));

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _DealPipelineStore = _interopRequireDefault(require("crm_data/deals/DealPipelineStore"));

var _propertyTranslator = require("property-translator/propertyTranslator");

var parseStage = function parseStage(stage, pipeline) {
  return stage.merge({
    pipelineDisplayOrder: pipeline.get('displayOrder'),
    pipelineId: pipeline.get('pipelineId'),
    pipelineLabel: (0, _propertyTranslator.propertyLabelTranslator)(pipeline.get('label')),
    text: (0, _propertyTranslator.propertyLabelTranslator)(stage.get('label')),
    value: stage.get('stageId')
  });
};

var DealStageStore = _generalStore.default.defineFactory().defineName('DealsStageStore').defineGetInitialState(function () {
  return (0, _immutable.Map)();
}).defineGet(function (state, dealStageId) {
  if (state.size === 0) {
    _DealPipelineStore.default.get();
  }

  if (dealStageId) {
    return state.get(dealStageId);
  }

  return state;
}).defineResponseTo(_ActionTypes.DEAL_PIPELINES_FETCH_SUCCEEDED, function (state, pipelines) {
  pipelines.forEach(function (pipeline) {
    return pipeline.get('stages').forEach(function (stage) {
      state = state.set(stage.get('stageId'), parseStage(stage, pipeline));
    });
  });
  return state;
}).defineResponseTo(_ActionTypes.PIPELINE_UPDATED, function (state, pipeline) {
  var value = pipeline.value;

  if (!value) {
    return state;
  }

  var stages = value.get('stages').sortBy(function (stage) {
    return stage.get('displayOrder');
  });
  stages.forEach(function (stage) {
    state = state.set(stage.get('stageId'), parseStage(stage, value));
  });
  return state;
}).defineResponseTo(_ActionTypes.PIPELINE_DELETED, function (state, pipelineId) {
  return state.filter(function (stage) {
    return stage.get('pipelineId') !== pipelineId;
  });
}).register(_dispatcher.default);

var _default = DealStageStore;
exports.default = _default;
module.exports = exports.default;